import { RootState, AppDispatch } from '@internal/redux'
import { TicketQueryParam } from '@shared/Services/QueryParamService'
import CreateTicketConversationService from '@internal/services/TicketConversationService'
import { fetchTicketDetailThunk } from './redux.thunks'
import { IReduxMapDispatch, IReduxMapState } from './redux.types'
import TicketDetailSlice from './redux.slice'

export const mapStateToProps = (state: RootState): IReduxMapState => ({
  status: state.TicketDetailSlice.status,
  requestedId: state.TicketDetailSlice.requestedId,
  slice: state.TicketDetailSlice
})

export const mapDispatchToProps = (dispatch: AppDispatch): IReduxMapDispatch => ({
  fetchData: () => {
    const q = TicketQueryParam.get()
    return dispatch(fetchTicketDetailThunk({ ticketId: q.ticketId, cleaned: true }))
  },
  onChangeStatus: (status) => {
    dispatch(TicketDetailSlice.actions.onChangeStatus(status))
  },
  CRUD: {
    Create: async (model) => {
      const q = TicketQueryParam.get()
      if (q.ticketId) {
        await CreateTicketConversationService(q.ticketId).Create(model)
        dispatch(fetchTicketDetailThunk({ ticketId: q.ticketId }))
      }
    }
  },
  refresh: async () => {
    const q = TicketQueryParam.get()
    dispatch(fetchTicketDetailThunk({ ticketId: q.ticketId, isRefresh: true }))
  }
})
